import { SchedulingResource } from '../Scheduling/Scheduling';

export interface DefaultBlockResource {
    id?: number;
    __component?: string;
    scheduling?: SchedulingResource;
}

export interface DefaultBlock {
    id?: string;
    type?: string;
    isPublished?: boolean;
}

export type BlockResource = DefaultBlockResource & unknown;
export type Block = DefaultBlock & unknown;

export enum BlockTypeResource {
    // Data
    topNavbar = 'data.top-navbar',
    blogOverview = 'data.blog-overview',
    blogsSelection = 'data.blogs-selection',
    highlightedBlogPost = 'data.blog-display',
    productCollection = 'data.product-selection-with-media',
    featuredProducts = 'data.products-view',
    productOverview = 'data.product-selection-with-filters',
    relatedBlogPosts = 'data.related-blog-posts',
    // General info
    urgentBanner = 'general-info.urgent-banner',
    // Display
    anchorTarget = 'display.anchor-target',
    brandCarousel = 'display.brands-carousel',
    categoriesCarousel = 'display.categories-carousel',
    iframe = 'display.iframe',
    faq = 'display.faq',
    service = 'display.service',
    uspSection = 'display.unique-selling-point',
    // TextImage
    carousel = 'text-image.carousel',
    contentColumns = 'text-image.content-columns',
    header = 'text-image.media',
    highlightedMedia = 'text-image.highlighted-media',
    iconColumns = 'text-image.icon-columns',
    mediaBanner = 'text-image.media-banner',
    mediaGrid = 'text-image.media-grid',
    // User input
    form = 'user-input.form',
    newsletterCallToAction = 'user-input.news-letter',
}

export enum BlockType {
    anchorTarget = 'anchorTarget',
    topNavbar = 'topNavbar',
    blogOverview = 'blogOverview',
    blogsSelection = 'blogsSelection',
    brandCarousel = 'brandCarousel',
    brandHeader = 'brandHeader',
    carousel = 'carousel',
    categorySlider = 'categorySlider',
    contentColumns = 'contentColumns',
    faqs = 'faqs',
    featuredProducts = 'featuredProducts',
    iframe = 'iframe',
    form = 'form',
    header = 'header',
    highlightedBlogPost = 'highlightedBlogPost',
    highlightedMedia = 'highlightedMedia',
    iconColumns = 'iconColumns',
    mediaBanner = 'mediaBanner',
    mediaGrid = 'mediaGrid',
    newsletterCallToAction = 'newsletterCallToAction',
    productCollection = 'productCollection',
    productOverview = 'productOverview',
    serviceSection = 'serviceSection',
    uspSection = 'uspSection'
}
